import React from 'react';

export const ArrowCarouselIcon = props => (
  <svg width={17} height={24} viewBox="0 0 15 20" {...props}>
    <defs>
      <filter x="-30.8%" y="-30.8%" width="161.5%" height="161.5%" filterUnits="objectBoundingBox" id="prefix__a">
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0952524038 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g filter="url(#prefix__a)" transform="translate(-11 -10)" fill="#647A85" fillRule="evenodd">
      <path d="M23.5 19.84a.891.891 0 01-.236.615l-6.579 6.834c-.292.305-.742.276-1.003-.063-.263-.34-.237-.862.055-1.164l5.972-6.207-5.96-5.903c-.298-.296-.334-.815-.079-1.163.255-.346.704-.387 1.003-.091l6.578 6.516c.156.155.247.38.249.618v.009z" />
    </g>
  </svg>
);
